import { propertyAreaUnitModel } from '@/models/api/propertyAreaUnit.model';

export const propertyAssetStatisticSummaryModel = (data) => ({
    totalAssets: data.total_assets,
    purchaseValueTotal: data.purchase_value_total,
    nbvValue: data.nbv_value,
    landSize: data.land_size,
    utilizeLandSize: data.utilize_land_size,
    utilizeLandSizePercentage: data.utilize_land_percentage,
    buildingSize: data.building_size,
    utilizeBuildingSize: data.utilize_building_size,
    utilizeBuildingPercentage: data.utilize_building_percentage,
    propertyAreaUnit: data.property_area_unit ? propertyAreaUnitModel(data.property_area_unit) : null,
});